import React from "react";
import Tender from "../../assets/image/png/tender.png";
const Tenders = () => {
  return (
    <div>
      {" "}
      <div className="py-5">
        <div className="container">
          <div className="row  align-items-center">
            <div className="col-lg-6 mt-4">
              <h5 className=" fs_24 ff_raleway fw-bold mb-0">
                Welcome to Our Drone Tender Enquiry Page
              </h5>

              <p className=" fs_16 ff_helvetica fw_400 mb-0 color_darkgray_3 pe-lg-5 mt-4">
                Thank you for your interest in our drone products and services.
                At Drone Planet, we specialize in providing cutting-edge drone
                solutions tailored to meet the diverse needs of various
                industries, including agriculture, surveying, delivery, and
                inspection. Whether you are looking to purchase drones, acquire
                specific drone parts, commission a custom drone build, or
                inquire about our maintenance and training services, you have
                come to the right place.
              </p>
              <p className=" fs_16 ff_helvetica fw_400 mb-0 color_darkgray_3 pe-lg-5 mt-4">
                To ensure we can serve you effectively, please fill out the
                following enquiry form with as much detail as possible. This
                will help us understand your requirements and provide you with
                the most accurate and efficient response. Our team of experts
                will review your submission and get back to you promptly with a
                tailored proposal or additional questions if necessary.
              </p>
            </div>{" "}
            <div className="col-lg-6 mt-5 mt-lg-0">
              <img className="w-100" src={Tender} alt="whyEnterprise_image1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tenders;
